import request from '../utils/request';

export function getGamesList(data) {
   return request({
      url: 'user/game/dropdown',
      method: 'get',
      data,
   });
}
